import type * as React from 'react';
import { get } from '@Domain/Api';
import aiProviderKindsFetched, {
	type AiProviderKindsFetchedAction,
	type AiProviderKindsFetchedPayload,
} from '@Application/Ai/AiProviderKinds/Actions/aiProviderKindsFetched';
import aiProviderKindsFetchFailed, {
	type AiProviderKindsFetchFailedAction,
} from '@Application/Ai/AiProviderKinds/Actions/aiProviderKindsFetchFailed';
import type FetchAiProviderKinds from '@Application/Ai/AiProviderKinds/Queries/FetchAiProviderKinds';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiProviderKindsFetchedAction | AiProviderKindsFetchFailedAction;

export default (_query: FetchAiProviderKinds) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiProviderKindsFetchedPayload>(
				`${parameters.api.host}/api/enums/ai-provider-kinds`,
			);

			const action = aiProviderKindsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiProviderKindsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
